import { Dropdown as AntdDropdown } from 'antd';
import classNames from 'classnames';
import * as React from 'react';
import './style/index';
import { jsx as _jsx } from "react/jsx-runtime";
const Dropdown = props => {
  const {
    isScroll,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    overlayClassName,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-dropdown");
  return /*#__PURE__*/_jsx(AntdDropdown, {
    overlayClassName: classNames(baseClassName, overlayClassName, {
      isScroll
    }),
    ...restProps
  });
};
export default Dropdown;